export enum BudgetTypes {
  NO_BUDGET_SELECTED = 'NO_BUDGET_SELECTED',
  TOTAL_PROJECT_HOURS = 'TOTAL_PROJECT_HOURS',
  TOTAL_PROJECT_FEES = 'TOTAL_PROJECT_FEES',
  HOURS_PER_TASK = 'HOURS_PER_TASK',
  HOURS_PER_PERSON = 'HOURS_PER_PERSON',
  FEES_PER_TASK = 'FEES_PER_TASK',
  TOTAL_BUDGET_AND_HOURS_PER_TASK = 'TOTAL_BUDGET_AND_HOURS_PER_TASK',
}
